!<template>
    <div>
        <footer>
            <div class="nbur">
                &copy; {{ new Date().getFullYear() }}, 
                Национальная библиотека Удмуртской Республики
            </div>

        </footer>
    </div>
</template>
<script>
export default {

}
</script>
<style>
footer {
  position: relative;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  justify-content: center;
  text-align: center;
}

.nbur {
  position: absolute;
    bottom: 10px;
    width: 100%;

}
</style>